<div class="content-block">

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h2 class="content-block">Consegna Giornaliera</h2>

                @if(isBase){
                <div class="button-esci">
                    <dx-button stylingMode="contained" type="default" text="Esci" class="dx-button-orange button-esci"
                        (onClick)="esci()" width="150">
                    </dx-button>
                </div>
                }
            </div>
        </div>
    </div>

    <div class="row g-3 mb-3">
        <!-- Caso monitor piccolo -->
        @if(isMax1600()){
        <div class="col-7 col-lg-4">
            <div class="row ">
                <div class="row schermo-piccolo">
                    <div class="card p-3 div-barcode">
                        <!--<h3 class="card-title font-weight-bold">Nuova consegna</h3>-->
                        <form id="form-nuova-consegna">
                            <dx-validation-group>
                                <div class="row">
                                    <div class="col-5 col-md-4">
                                        <dx-date-box #data displayFormat=" dd/MM/yyyy" [(value)]="dataConsegna"
                                            width="100%">
                                            <dx-validator>
                                                <dxi-validation-rule type="required"
                                                    message="Selezionare la data"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-date-box>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="div-dipendente">
                                        <div class="col-5 col-md-4">
                                            <dx-text-box #barcodeDipendente [(value)]="codiceDipendente"
                                                placeholder="Barcode Dipendente" valueChangeEvent="keyup"
                                                (onEnterKey)="onCodiceDipendenteChanged()"
                                                (onContentReady)="onBarcodeDipendenteTxtBoxInitialized($event)"
                                                [(disabled)]="dipendenteInserito">

                                            </dx-text-box>
                                        </div>
                                        <div class="col-5 col-md-5">
                                            <dx-text-box [(value)]="dipendente" [disabled]="true"
                                                class="disabled-txt"></dx-text-box>
                                        </div>
                                        @if(buttonDipendente){
                                        <dx-button stylingMode="contained" text="Cerca" icon="search" type="normal"
                                            (onClick)="onDipendenteCerca()" class="button-cerca">
                                        </dx-button>
                                        }
                                    </div>
                                </div>
                                @if(sezioneArticolo){
                                <div class="row">
                                    <div class="barcode-articolo">
                                        <div class="col-5 col-md-4">
                                            <dx-text-box #barcodeArticolo [(value)]="codiceArticolo"
                                                placeholder="Barcode Articolo" valueChangeEvent="keyup"
                                                (onEnterKey)="onBarcodeArticolo()"
                                                (onContentReady)="onBarcodeArticoloTxtBoxInitialized($event)">

                                            </dx-text-box>
                                        </div>
                                        <dx-button stylingMode="contained" text="Cerca" icon="search" type="normal"
                                            (onClick)="onArticoloCerca()" class="button-cerca">
                                        </dx-button>
                                    </div>
                                </div>
                                }
                            </dx-validation-group>
                        </form>
                    </div>
                </div>
                <div class="row schermo-piccolo">
                    <div class="card p-3 div-barcode">
                        <!--<h3 class="card-title font-weight-bold">Nuova consegna</h3>-->
                        @if(gestioneMatricola && matricolaRigaSelezionata == undefined){

                        <div class="row matricole-div">
                            <div class="col-12 header-matricola">

                                <i class="dx-icon-warning warning-icon"></i>
                                <h4>Inserire la matricola dell'articolo</h4>

                            </div>

                            <dx-text-box #barcodeMatricola class="col-9" [(value)]="matricolaArticolo"
                                placeholder="Matricola Articolo" valueChangeEvent="keyup"
                                (onEnterKey)="onMatricolaArticolo()">
                            </dx-text-box>

                            <dx-button stylingMode="contained" text="Cerca" icon="search" type="normal"
                                (onClick)="onMatricolaCerca()" class="button-cerca">
                            </dx-button>
                        </div>

                        }
                        @if(gestioneMatricola && matricolaRigaSelezionata != undefined){
                        <div class="matricole-div">
                            <div class="col-12 header-matricola">

                                <i class="dx-icon-check check-icon"></i>
                                <h4>Matricola Inserita</h4>
                                <p>{{getDescrizione()}}</p>
                            </div>
                        </div>
                        }
                        @if(!gestioneMatricola && rigaSelezionata != undefined){
                        <div class="matricole-div">
                            <div class="col-12 header-matricola">

                                @if(needVerificaGiacenza() && qtaInsufficiente() && rigaSelezionata != undefined){
                                <i class="dx-icon-warning warning-icon"></i>
                                <h4>Quantità articolo non sufficiente</h4>
                                <p>{{getDescrizione()}}</p>
                                @if(intVerificaSottoscorta == 1){
                                <p><b>NB:</b>Puoi comunque consegnare l'articolo</p>
                                }
                                }@else{
                                <i class="dx-icon-check check-icon"></i>
                                <h4>Articolo Valido</h4>
                                <p>{{getDescrizione()}}</p>
                                }

                            </div>
                        </div>
                        }

                    </div>
                </div>
            </div>

        </div>
        <div class="col-12 col-lg-8">
            <div class="card p-3">
                <div class="row ">
                    <h4>Articoli Consegnati:</h4>
                </div>
                <dx-data-grid #gridDettaglioMov [dataSource]="nuovoMovimento.listDettaglio" keyExpr="dataInserimento"
                    [showBorders]="true" [focusedRowEnabled]="true" [focusedRowIndex]="0" [columnAutoWidth]="true"
                    [columnHidingEnabled]="false" (onInitNewRow)="onInitNewRow($event)"
                    (onFocusedRowChanged)="onFocusedRowChanged($event)" (onRowInserting)="onRowInserting($event)"
                    (onEditorPreparing)="onEditorPreparing($event)" (onRowUpdated)="rowUpdated($event)"
                    (onSelectionChanged)="onSelectionChanged($event)" (onRowPrepared)="onRowPrepared($event)"
                    [editing]="{mode: 'cell'}" [showRowLines]="true" [showColumnLines]="true">
                    <!-- (onRowInserted)="onRowInserted($event)" -->

                    <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="true" [allowDeleting]="true"
                        [useIcons]="true">
                    </dxo-editing>


                    <dxo-selection mode="single"></dxo-selection>


                    <dxi-column dataField="dataInserimento" sortOrder="asc" sortIndex="0" [visible]="false">
                    </dxi-column>

                    <dxi-column type="buttons" width="40px" caption="" [allowSorting]="false">
                        <dxi-button name="delete" hint="Elimina articolo" [onClick]="eliminaArticolo"></dxi-button>
                    </dxi-column>

                    <dxi-column cellTemplate="validoTemplate" width="50" alignment="center" [allowSorting]="false"
                        [allowEditing]="false"></dxi-column>

                    <div *dxTemplate="let d of 'validoTemplate'">
                        @if((d.data.usaMatricola && d.data.matricola == undefined) || qtaInsufficiente(d.data.idArticolo)){
                        <i class="dx-icon-clearcircle color-red"></i>
                        }
                        @else{
                        <i class="dx-icon-check color-blue"></i>
                        }
                    </div>

                    <dxi-column dataField="qta" caption="Qtà" dataType="number" width="60" alignment="center"
                        [cellTemplate]="'viewQta'" [editCellTemplate]="'editQta'" [allowSorting]="false">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-column>

                    <div *dxTemplate="let d of 'viewQta'">
                        {{d.value}}
                    </div>

                    <div *dxTemplate="let d of 'editQta'">
                        <dx-number-box [value]="d.value" [showSpinButtons]="true" [min]="0" [step]="1"
                            [readOnly]="d.data.usaMatricola" (onValueChanged)="onQtaChanged($event, d.data)">
                        </dx-number-box>
                    </div>

                    <dxi-column cellTemplate="kitTemplate" caption="Kit" width="30" alignment="center"
                        [allowSorting]="false" [allowEditing]="false"></dxi-column>

                    <div *dxTemplate="let d of 'kitTemplate'">
                        @if(d.data.kit){
                        <i class="dx-icon-check color-blue"></i>
                        }
                        @if(d.data.componenteFiglio){
                        <i class="dx-icon-hierarchy color-blue"></i>
                        }
                    </div>

                    <dxi-column dataField="idTipoArticolo" dataField="idTipoArticolo" caption="Tipologia" width="160px"
                        [allowSorting]="false" [setCellValue]="onTipoArticoloChanged" width="300"
                        [allowEditing]="false">
                        <dxo-lookup [dataSource]="listTipiArticoli" valueExpr="id"
                            displayExpr="descrizione"></dxo-lookup>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-column>


                    <dxi-column dataField="idArticolo" caption="Articolo" cellTemplate="descrizioneArticolo"
                        [allowSorting]="false" alignment="left" width="300" [allowEditing]="false">

                    </dxi-column>
                    <div *dxTemplate="let d of 'descrizioneArticolo'">
                        {{getArticoloDisplay(d.data)}}
                    </div>



                </dx-data-grid>
                <div class="row single-button">
                    <dx-button stylingMode="contained" type="default" text="Annulla" class="dx-button-orange"
                        (onClick)="ripulisciDati()" width="150">
                    </dx-button>
                    <dx-button stylingMode="contained" type="default" text="Conferma" class="dx-button-orange"
                        (onClick)="effettuaConsegna($event)" width="150">
                    </dx-button>
                </div>
            </div>

        </div>
        }
        <!-- Caso di monitor grande -->
        @else {
        <div class="col-7 col-lg-4">
            <div class="card p-3 div-barcode">
                <!--<h3 class="card-title font-weight-bold">Nuova consegna</h3>-->
                <form id="form-nuova-consegna">
                    <dx-validation-group>
                        <div class="row">
                            <div class="col-5 col-md-4">
                                <dx-date-box #data displayFormat=" dd/MM/yyyy" [(value)]="dataConsegna" width="100%">
                                    <dx-validator>
                                        <dxi-validation-rule type="required"
                                            message="Selezionare la data"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-date-box>

                            </div>
                        </div>
                        <div class="row">
                            <div class="div-dipendente">
                                <div class="col-5 col-md-4">
                                    <dx-text-box #barcodeDipendente [(value)]="codiceDipendente"
                                        placeholder="Barcode Dipendente" valueChangeEvent="keyup"
                                        (onEnterKey)="onCodiceDipendenteChanged()"
                                        (onContentReady)="onBarcodeDipendenteTxtBoxInitialized($event)"
                                        [(disabled)]="dipendenteInserito">

                                    </dx-text-box>
                                </div>
                                <div class="col-5 col-md-5">
                                    <dx-text-box [(value)]="dipendente" [disabled]="true"
                                        class="disabled-txt"></dx-text-box>
                                </div>
                                @if(buttonDipendente){
                                <dx-button stylingMode="contained" text="Cerca" icon="search" type="normal"
                                    (onClick)="onDipendenteCerca()" class="button-cerca">
                                </dx-button>
                                }
                            </div>
                        </div>
                        @if(sezioneArticolo){
                        <div class="row">
                            <div class="barcode-articolo">
                                <div class="col-5 col-md-4">
                                    <dx-text-box #barcodeArticolo [(value)]="codiceArticolo"
                                        placeholder="Barcode Articolo" valueChangeEvent="keyup"
                                        (onEnterKey)="onBarcodeArticolo()"
                                        (onContentReady)="onBarcodeArticoloTxtBoxInitialized($event)">

                                    </dx-text-box>
                                </div>
                                <dx-button stylingMode="contained" text="Cerca" icon="search" type="normal"
                                    (onClick)="onArticoloCerca()" class="button-cerca">
                                </dx-button>
                            </div>
                        </div>
                        }
                    </dx-validation-group>
                </form>
            </div>
        </div>
        <div class="col-5 col-lg-2 div-barcode">
            <div class="card p-3 div-barcode">
                <!--<h3 class="card-title font-weight-bold">Nuova consegna</h3>-->
                @if(gestioneMatricola && matricolaRigaSelezionata == undefined){

                <div class="row matricole-div">
                    <div class="col-12 header-matricola">

                        <i class="dx-icon-warning warning-icon"></i>
                        <h4>Inserire la matricola dell'articolo</h4>

                    </div>

                    <dx-text-box #barcodeMatricola class="col-9" [(value)]="matricolaArticolo"
                        placeholder="Matricola Articolo" valueChangeEvent="keyup" (onEnterKey)="onMatricolaArticolo()">
                    </dx-text-box>

                    <dx-button stylingMode="contained" text="Cerca" icon="search" type="normal"
                        (onClick)="onMatricolaCerca()" class="button-cerca">
                    </dx-button>
                </div>

                }
                @if(gestioneMatricola && matricolaRigaSelezionata != undefined){
                <div class="matricole-div">
                    <div class="col-12 header-matricola">

                        <i class="dx-icon-check check-icon"></i>
                        <h4>Matricola Inserita</h4>
                        <p>{{getDescrizione()}}</p>
                    </div>  
                </div>
                }
                @if(!gestioneMatricola && rigaSelezionata != undefined){
                <div class="matricole-div">
                    <div class="col-12 header-matricola">
                        @if(needVerificaGiacenza() && qtaInsufficiente() && rigaSelezionata != undefined){
                        <i class="dx-icon-warning warning-icon"></i>
                        <h4>Quantità articolo non sufficiente</h4>
                        <p>{{getDescrizione()}}</p>
                        @if(intVerificaSottoscorta == 1){
                        <p><b>NB:</b>Puoi comunque consegnare l'articolo</p>
                        }
                        }@else{
                        <i class="dx-icon-check check-icon"></i>
                        <h4>Articolo Valido</h4>
                        <p>{{getDescrizione()}}</p>
                        }
                    </div>
                </div>
                }

            </div>
        </div>
        <div class="col-12 col-lg-6">
            <div class="card p-3">
                <div class="row ">
                    <h4>Articoli Consegnati:</h4>
                </div>
                <dx-data-grid #gridDettaglioMov [dataSource]="nuovoMovimento.listDettaglio" keyExpr="dataInserimento"
                    [showBorders]="true" [focusedRowEnabled]="true" [focusedRowIndex]="0" [columnAutoWidth]="true"
                    [columnHidingEnabled]="false" (onInitNewRow)="onInitNewRow($event)"
                    (onFocusedRowChanged)="onFocusedRowChanged($event)" (onRowInserting)="onRowInserting($event)"
                    (onEditorPreparing)="onEditorPreparing($event)" (onRowUpdated)="rowUpdated($event)"
                    (onSelectionChanged)="onSelectionChanged($event)" (onRowPrepared)="onRowPrepared($event)"
                    [editing]="{mode: 'cell'}" [showRowLines]="true" [showColumnLines]="true">
                    <!-- (onRowInserted)="onRowInserted($event)" -->

                    <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="true" [allowDeleting]="true"
                        [useIcons]="true">
                    </dxo-editing>


                    <dxo-selection mode="single"></dxo-selection>


                    <dxi-column dataField="dataInserimento" sortOrder="asc" sortIndex="0" [visible]="false">
                    </dxi-column>

                    <dxi-column type="buttons" width="40px" caption="" [allowSorting]="false">
                        <dxi-button name="delete" hint="Elimina articolo" [onClick]="eliminaArticolo"></dxi-button>
                    </dxi-column>

                    <dxi-column cellTemplate="validoTemplate" width="50" alignment="center" [allowSorting]="false"
                        [allowEditing]="false"></dxi-column>

                    <div *dxTemplate="let d of 'validoTemplate'">
                        @if((d.data.usaMatricola && d.data.matricola == undefined) || qtaInsufficiente(d.data.idArticolo) ){
                        <i class="dx-icon-clearcircle color-red"></i>
                        }
                        @else{
                        <i class="dx-icon-check color-blue"></i>
                        }
                    </div>

                    <dxi-column dataField="qta" caption="Qtà" dataType="number" width="60" alignment="center"
                        [cellTemplate]="'viewQta'" [editCellTemplate]="'editQta'" [allowSorting]="false">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-column>

                    <div *dxTemplate="let d of 'viewQta'">
                        {{d.value}}
                    </div>

                    <div *dxTemplate="let d of 'editQta'">
                        <dx-number-box [value]="d.value" [showSpinButtons]="true" [min]="0" [step]="1"
                            [readOnly]="d.data.usaMatricola" (onValueChanged)="onQtaChanged($event, d.data)">
                        </dx-number-box>
                    </div>

                    <dxi-column cellTemplate="kitTemplate" caption="Kit" width="30" alignment="center"
                        [allowSorting]="false" [allowEditing]="false"></dxi-column>

                    <div *dxTemplate="let d of 'kitTemplate'">
                        @if(d.data.kit){
                        <i class="dx-icon-check color-blue"></i>
                        }
                        @if(d.data.componenteFiglio){
                        <i class="dx-icon-hierarchy color-blue"></i>
                        }
                    </div>

                    <dxi-column dataField="idTipoArticolo" dataField="idTipoArticolo" caption="Tipologia" width="160px"
                        [allowSorting]="false" [setCellValue]="onTipoArticoloChanged" width="300"
                        [allowEditing]="false">
                        <dxo-lookup [dataSource]="listTipiArticoli" valueExpr="id"
                            displayExpr="descrizione"></dxo-lookup>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-column>


                    <dxi-column dataField="idArticolo" caption="Articolo" cellTemplate="descrizioneArticolo"
                        [allowSorting]="false" alignment="left" [allowEditing]="false">

                    </dxi-column>
                    <div *dxTemplate="let d of 'descrizioneArticolo'">
                        {{getArticoloDisplay(d.data)}}
                    </div>



                </dx-data-grid>
                <div class="row single-button">
                    <dx-button stylingMode="contained" type="default" text="Annulla" class="dx-button-orange"
                        (onClick)="ripulisciDati()" width="150">
                    </dx-button>
                    <dx-button stylingMode="contained" type="default" text="Conferma" class="dx-button-orange"
                        (onClick)="effettuaConsegna($event)" width="150">
                    </dx-button>
                </div>
            </div>
        </div>
        }
    </div>

    @if(popupSceltaDipendente){
    <dx-popup [width]="600" [height]="230" [showTitle]="true" title="" [dragEnabled]="false" [hideOnOutsideClick]="true"
        [(visible)]="popupSceltaDipendente">
        <app-popup-scelta-dipendente [listDipendenti]="listDipendenti"
            (idDipendenteEventEmitter)="onIdDipendenteEventEmitter($event)"></app-popup-scelta-dipendente>
    </dx-popup>
    }

    @if(popupSceltaArticolo){
    <dx-popup [width]="600" [height]="230" [showTitle]="true" title="" [dragEnabled]="false" [hideOnOutsideClick]="true"
        [(visible)]="popupSceltaArticolo">
        <app-popup-scelta-articolo (articoloEventEmitter)="onArticoloEventEmitter($event)"></app-popup-scelta-articolo>
    </dx-popup>
    }

    @if(popupSceltaMatricola){
    <dx-popup [width]="600" [height]="230" [showTitle]="true" title="" [dragEnabled]="false" [hideOnOutsideClick]="true"
        [(visible)]="popupSceltaMatricola">
        <app-popup-scelta-matricola [listMatricole]="listMatricoleDisponibiliFiltrate"
            (idMatricolaEventEmitter)="onIdMatricolaEventEmitter($event)"></app-popup-scelta-matricola>
    </dx-popup>
    }


    <dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="visibleLoadPanel" [showIndicator]="true"
        [showPane]="true" [shading]="true" [hideOnOutsideClick]="false" message="Inoltro consegna">
    </dx-load-panel>